import firebase from 'firebase/app';
import axios from 'axios';
export class BaseService {
	getDocRef(path) {
		return firebase.firestore().doc(path);
	}
	getCollectionRef(collection) {
		return firebase.firestore().collection(collection);
	}
	update(docRef, data) {
		if (typeof docRef.update !== 'Function') {
			throw new NotAFirestoreReferenceException();
		}
		return docRef.update(data);
	}
	delete(docRef) {
		if (typeof docRef.delete !== 'Function') {
			throw new NotAFirestoreReferenceException();
		}
		return docRef.delete();
	}
	set(docRef, data, doMerge) {
		if (typeof docRef.delete !== 'Function') {
			throw new NotAFirestoreReferenceException();
		}
		return docRef.set(data, { merge: doMerge });
	}
	add(collectionRef, data) {
		if (typeof docRef.add !== 'Function') {
			throw new NotAFirestoreReferenceException();
		}
		return docRef.delete();
	}
	getTransaction(fn) {
		return firebase.firestore().runTransaction(fn);
	}
	getServerTimestamp(){
		return firebase.firestore.FieldValue.serverTimestamp();
	}
	getCallableFunction(name){
		return firebase.functions().httpsCallable(name);
	}
	async httpPost(_url, data, onUploadCallback){
		return this.http(_url, 'POST', data, onUploadCallback);
	}
	async http(url, method, data, onUploadCallback, sendFiles){
		console.log('http.request ', url);
		const token = await firebase.auth().currentUser.getIdToken();

		method = String(method).toLowerCase();
		let contentType = 'application/json';
		if(sendFiles){
			contentType = 'multipart/form-data';
		}
		
		const response = await axios({
			method: method,
			url: `${process.env.VUE_APP_API_URL}${url}`,
			headers: {
				'Authorization': `Bearer ${token}`,
				'Content-Type': 'application/json'
			},
			data: data,
			onUploadProgress: onUploadCallback
		});
		console.log('http.response ', response.data);
		return response.data;
	}

	static async getHeaders(){
		const token = await firebase.auth().currentUser.getIdToken();
		return {
			'Authorization': `Bearer ${token}`,
			'Content-Type': 'application/json'
		};
	}
}
class NotAFirestoreReferenceException extends Error {
	message = 'Param is not a document ref';
}
